/* eslint-disable*/
import React, { Component } from "react";
import FormGroupNeeds from "./form/FormGroupNeeds";
import { connect } from "react-redux";
import {
  setIsCommValueChanged,
  setCommValue,
  setvalueCofirm
} from "../../actions/policy/policyActions";
import Store from "../../content/Store";
import FormGroupNeedsComm from "./form/FormGroupNeedsComm";

const mapDispatchToProps = (dispatch) => {
  return {
    setIsCommValueChanged: (Value) => dispatch(setIsCommValueChanged(Value)),
    setCommValue: (Value) => dispatch(setCommValue(Value)),
    setvalueCofirm: (Value) => dispatch(setvalueCofirm(Value))

  };
};
export const mapStateToProps = ({ preferenceConfirmReducer = {} }) => {
  return {
    prefval: preferenceConfirmReducer && preferenceConfirmReducer.PrefSelection
  };
};

export class SetCommPreferenceSection extends Component {

  constructor(props) {
    super(props);
    this.state = {
      CommPreference: [],
      optionValue: false,
      PrefSecValue: true,
      IsCommIdSelected:false
    };
     this.PreferenceChanges = this.PreferenceChanges.bind(this);
     this.updatedValue = this.updatedValue.bind(this);
  }

  componentDidMount() {
    let updateCommPrefs = [];
    if (this.props.commPrefsKeys !== undefined && this.props.commPrefsKeys !== null) {
      if (this.props.communicationValue !== null && this.props.communicationValue !== undefined) {
        this.props.communicationValue.forEach((value) => {
          let updateValue = {
            PersonCommPrefId: value.PersonCommPrefId,
            PersonId: value.PersonId,
            CommunicationPreferenceId: value.CommunicationPreferenceId,
            CommunicationPreferenceName: value.CommunicationPreferenceName,
            CreatedBy: value.CreatedBy,
            LastUpdatedBy: value.LastUpdatedBy,
            SourceSystem: value.SourceSystem,
            SourcePersonId: value.SourcePersonId,
            IsDeleted: value.IsDeleted
          };
          updateCommPrefs.push(updateValue);
        });
        this.setState({
          CommPreference: updateCommPrefs
        }, () => {
          this.updateCommPreferences(this.state.CommPreference);
        });
      }
    }
  }

  componentDidUpdate(prevProps) {


    if (this.props.prefval !== null && this.props.prefval !== undefined && prevProps.prefval !== this.props.prefval) {
      let prefvaid = this.props.prefval.split('&')[1];
      const masterData = this.props.commPrefsKeys.filter((val) => val.CommunicationPreferenceId.toString() === prefvaid);
       if (this.props.prefval.includes('No')) {
      //   this.IsCommValueChanged(true);
        this.props.setIsCommValueChanged(true);
        const commPref = this.state.CommPreference;
        const index = commPref.findIndex(m => m.CommunicationPreferenceId === prefvaid);
        this.setState({
          CommPreference: commPref
        });
        //}
        this.props.setCommValue(commPref);
        this.updateCommPreferences(this.state.CommPreference);
        this.setState({
          optionValue: false, PrefSecValue: true
        });
      }
      else {
        //New entry(No -> yes)
        let newValue;
        if (this.props.communicationValue !== null) {
          newValue = {
            PersonCommPrefId: 0,
            PersonId: this.state.CommPreference[0].PersonId,
            CommunicationPreferenceId: masterData[0].CommunicationPreferenceId,
            CommunicationPreferenceName: masterData[0].CommunicationPreferenceName,
            CreatedBy: this.props.MemberName,
            LastUpdatedBy: this.props.MemberName,
            SourceSystem: this.state.CommPreference[0].SourceSystem,
            SourcePersonId: this.state.CommPreference[0].SourcePersonId,
            IsDeleted: false
          };
        }
        else {
          newValue = {
            PersonCommPrefId: 0,
            PersonId: "",
            CommunicationPreferenceId: masterData[0].CommunicationPreferenceId,
            CommunicationPreferenceName: masterData[0].CommunicationPreferenceName,
            CreatedBy: this.props.MemberName,
            LastUpdatedBy: this.props.MemberName,
            SourceSystem: "",
            SourcePersonId: "",
            IsDeleted: false
          };
        }
        const newArrayVal = this.state.CommPreference;
        //newArrayVal.push(newValue);
        this.setState({
          CommPreference: newArrayVal
        });
        this.props.setCommValue(newArrayVal);
        this.updateCommPreferences(this.state.CommPreference);
      }
    }

    if (JSON.stringify(prevProps.communicationValue) !== JSON.stringify(this.props.communicationValue)) {
      this.updatedValue(this.props.communicationValue);
    }
  }

  updatedValue(communicationValue) {
    if (communicationValue !== null) {
      this.setState({
        CommPreference: communicationValue,
      });
    }
    else {
      this.setState({
        CommPreference: [],
      });
    }

  }


  PreferenceChanges(event, CommunicationPreferenceId) {
    this.setState({IsCommIdSelected : this.props.SelectionOption});
    if (event.target.value === 'No') {
      this.props.setvalueCofirm('No' + '&' + CommunicationPreferenceId);
    }
    else {
      this.props.setvalueCofirm('No' + '&' + CommunicationPreferenceId);
    }
    this.IsCommValueChanged(true);
    this.props.setIsCommValueChanged(true);
    const commPref = this.state.CommPreference;
    const index = commPref.findIndex(m => m.CommunicationPreferenceId === CommunicationPreferenceId);
    const masterData = this.props.commPrefsKeys.filter((val) => val.CommunicationPreferenceId === CommunicationPreferenceId);
    if (index !== -1) {
      let existflag = [];
      if (this.props.communicationValue !== null && this.props.communicationValue !== undefined) {
        let originalValue = this.props.communicationValue;
        existflag = originalValue.filter(value => {
          return value.CommunicationPreferenceId === commPref[index].CommunicationPreferenceId;
        });
      }
      if (existflag.length !== 0 && commPref[index].PersonCommPrefId !== 0) {
        //Add or delete from existing preference
        //commPref[index].IsDeleted = event.target.value === "Yes" ? true : false;
      }
      else {
        // delete entry from existing array(No->yes->No)
         //commPref.splice(index, 1);
      }


      this.setState({
        CommPreference: commPref
      });
      this.setState({
        optionValue: true
      });
    }         
    else {
      //New entry(No -> yes)
      let newValue;
      
      if (this.props.communicationValue !== null) {
        newValue = {
          PersonCommPrefId: 0,
          PersonId: this.state.CommPreference[0].PersonId,
          CommunicationPreferenceId: masterData[0].CommunicationPreferenceId,
          CommunicationPreferenceName: masterData[0].CommunicationPreferenceName,
          CreatedBy: this.props.MemberName,
          LastUpdatedBy: this.props.MemberName,
          SourceSystem: this.state.CommPreference[0].SourceSystem,
          SourcePersonId: this.state.CommPreference[0].SourcePersonId,
          IsDeleted: false
        };
      }
      else {
        newValue = {
          PersonCommPrefId: 0,
          PersonId: "",
          CommunicationPreferenceId: masterData[0].CommunicationPreferenceId,
          CommunicationPreferenceName: masterData[0].CommunicationPreferenceName,
          CreatedBy: this.props.MemberName,
          LastUpdatedBy: this.props.MemberName,
          SourceSystem: "",
          SourcePersonId: "",
          IsDeleted: false
        };
      }
      const newArrayVal = this.state.CommPreference;
      newArrayVal.push(newValue);
      this.setState({
        CommPreference: newArrayVal
      });
    }
    var commIds =[0,1,2,3,5];
    if (commIds.includes(CommunicationPreferenceId)){
      this.setState({IsCommIdSelected : true});
    }
    this.updateCommPreferences(this.state.CommPreference);
  }

  updateCommPreferences(CommPreference) {
    this.props.updateCommPreferences(CommPreference);
  }

  IsCommValueChanged(value) {
    this.props.setIsCommValueChanged(value);
  }

  poupconfirmation(val){
     var commid = val.split('&')[1];
    if (val.includes('Yes') && (commid === "0" || commid === "1" || commid === "2" || commid === "3" || commid === "5")) {
      this.setState({IsCommIdSelected : true});
    }else{
      this.setState({IsCommIdSelected:false});
    }
  }

  render() {
    const idx1 = this.props.commPrefsKeys.some(m => m.CommunicationPreferenceId.toString() === "0")
    if(idx1 === false) {
    let newValue = {CommunicationPreferenceId:0,
      CommunicationPreferenceName:"No thanks",
      ShowAlertToAgent:true
    };
   
    this.props.commPrefsKeys.unshift(newValue);
  }
    if (this.props.commPrefsKeys !== undefined && this.props.commPrefsKeys !== null) {
      
      return this.props.commPrefsKeys.length > 0 && this.props.commPrefsKeys.map((informMethod, index) => {
        if(informMethod.CommunicationPreferenceId !== 4 && informMethod.CommunicationPreferenceId !== 7 )
        {
        let communicationOptionValue = false;
        let Descriptionsss = null;
        let CommDescription = null;

        // console.log('this.props.commPrefsKeys'+this.props.commPrefsKeys);

        let CommConfirmation = Store.MyProfileCommunicationNeeds.OnboadingConfirmation;
        if (this.props.communicationValue !== null && this.props.communicationValue !== undefined) {
          communicationOptionValue = this.props.communicationValue.some(val => val.CommunicationPreferenceId === informMethod.CommunicationPreferenceId);
        }
        if (this.state.CommPreference.length !== 0) {
          communicationOptionValue = this.state.CommPreference.some(val => val.CommunicationPreferenceId === informMethod.CommunicationPreferenceId);
        }
        if (informMethod.CommunicationPreferenceId === 0) {
          Descriptionsss = Store.MyProfileCommunicationNeeds.OnboadingHeading.NoThanks;
        }
        if (informMethod.CommunicationPreferenceId === 1) {
          Descriptionsss = Store.MyProfileCommunicationNeeds.OnboadingHeading.DocumentsInBraille;
          CommDescription = Store.MyProfileCommunicationNeeds.OnboadingDescription.DocumentsInBraille;
        }
        if (informMethod.CommunicationPreferenceId === 2) {
          Descriptionsss = Store.MyProfileCommunicationNeeds.OnboadingHeading.DocumentsInLargePrint;
          CommDescription = Store.MyProfileCommunicationNeeds.OnboadingDescription.DocumentsInLargePrint;
        }
        if (informMethod.CommunicationPreferenceId === 3) {
          Descriptionsss = Store.MyProfileCommunicationNeeds.OnboadingHeading.Audio;
          CommDescription = Store.MyProfileCommunicationNeeds.OnboadingDescription.Audio;
        }
        if (informMethod.CommunicationPreferenceId === 5) {
          Descriptionsss = Store.MyProfileCommunicationNeeds.OnboadingHeading.Dyslexicprint;
          CommDescription = Store.MyProfileCommunicationNeeds.OnboadingDescription.Dyslexicprint;
        }
        // if (informMethod.CommunicationPreferenceId === 4) {
        //   Descriptionsss = Store.MyProfileCommunicationNeeds.OnboadingHeading.SignLanguageService;
        //   CommDescription = Store.MyProfileCommunicationNeeds.OnboadingDescription.SignLanguageService;
        // }
        // if (informMethod.CommunicationPreferenceId === 7) {
        //   Descriptionsss = Store.MyProfileCommunicationNeeds.OnboadingHeading.RelayUK;
        //   CommDescription = Store.MyProfileCommunicationNeeds.OnboadingDescription.RelayUK;
        // }
        // console.log(this.props.prefval!==null && this.props.prefval.includes('No'));
        return (
          this.props.mfa ? 
          <FormGroupNeedsComm
            className={"form-group mt-0"}
            type="yesno"
            id={"comm" + informMethod.CommunicationPreferenceName}
            commId={informMethod.CommunicationPreferenceId.toString()}
            label={informMethod.CommunicationPreferenceName}
            key={informMethod.CommunicationPreferenceName}
            description={Descriptionsss}
            currentValue={communicationOptionValue}
            Layout={this.props.Layout}
            poupconfirmation={this.props.prefval !== null &&
              informMethod.CommunicationPreferenceId === this.props.prefval.split('&')[1] && this.props.prefval.includes('No') ? false : true}
            onChange={(event) => {
              this.PreferenceChanges(event, informMethod.CommunicationPreferenceId);
              return event.target.value === 'Yes'
                ? true
                : event.target.value === 'No'
                  ? false
                  : null;
            }
            }
            SelectionOption={this.props.SelectionOption && !this.state.IsCommIdSelected}
            PrefSecValue={this.state.PrefSecValue}
            Zebrafied={this.props.Zebrafied}
            UseSlider={this.props.UseSlider}
            CommDescription={CommDescription}
            CommConfirmation={CommConfirmation}
            poupconfirmations={(val)=>this.poupconfirmation(val)}
          />:

          <FormGroupNeeds
            className={"form-group mt-0"}
            type="yesno"
            id={"comm" + informMethod.CommunicationPreferenceName}
            commId={informMethod.CommunicationPreferenceId.toString()}
            label={informMethod.CommunicationPreferenceName}
            key={informMethod.CommunicationPreferenceName}
            description={Descriptionsss}
            currentValue={communicationOptionValue}
            Layout={this.props.Layout}
            poupconfirmation={this.props.prefval !== null &&
              informMethod.CommunicationPreferenceId === this.props.prefval.split('&')[1] && this.props.prefval.includes('No') ? false : true}
            onChange={(event) => {
              this.PreferenceChanges(event, informMethod.CommunicationPreferenceId);
              return event.target.value === 'Yes'
                ? true
                : event.target.value === 'No'
                  ? false
                  : null;
            }
            }
            SelectionOption={this.props.SelectionOption && !this.state.IsCommIdSelected}
            PrefSecValue={this.state.PrefSecValue}
            Zebrafied={this.props.Zebrafied}
            UseSlider={this.props.UseSlider}
            CommDescription={CommDescription}
            CommConfirmation={CommConfirmation}
            poupconfirmations={(val)=>this.poupconfirmation(val)}
          />
        );
      }
      });
    }
    return null;
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SetCommPreferenceSection);